import state from './moduleCharitiesState.js'
import mutations from './moduleCharitiesMutations.js'
import actions from './moduleCharitiesActions.js'
import getters from './moduleCharitiesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

